var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterXRoxo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79614 11.1302L0.045045 20H1.8018L8.57776 12.2461L14.009 20H20L11.9032 8.44063L19.2793 0H17.5225L11.1216 7.32475L5.99099 0H0L7.79614 11.1302ZM2.73804 1.4128L14.7679 18.5872H17.262L5.23214 1.4128H2.73804Z",
    fill: "#541084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterXRoxo);
export default __webpack_public_path__ + "static/media/twitter-xRoxo.4af2be35411441986578aa6e1343de13.svg";
export { ForwardRef as ReactComponent };